import React, { useRef, useState } from 'react';
import { UserAvatar, ToastNotification, Popup, ProgressLoader } from "components/shared";
import { TaskService } from "services/http";
import { ConfirmPopup } from "primereact/confirmpopup";
import "./task.scss";
import utils, { INTERVENTION_STATUS } from 'utils';
import { TaskEnclose } from './task-enclose';
import { TaskTransfer } from './task-transfer';
import { TaskDefferHoc } from 'components/layout/sidebar/tasks-part/task-deffer';
import $ from "jquery";

export const TaskItem = (props) => {

    const isCurrentTask = () => {
        let currentTask = JSON.parse(new URLSearchParams(window.location.search).get("task"));
        return currentTask?.interventionId === props.taskId;
    }

    return (
        <div id={props.taskId} className={`task-item mx-2 my-1`} onClick={props.dealActionTask}>
            <div className={`text-justify justify-content-between d-flex py-1 px-1 ${props.direction === "incoming" ? "nodealed-header-task" : "dealed-header-task"}`} style={{ borderRadius: "5px 5px 0 0" }}>
                <div className="text-justify d-flex py-1 px-1">
                    <UserAvatar image={props.avatar} size="small" shape="circle" />&nbsp;
                    <div className="d-block">
                        <div>{utils.shorthandString(props.title, 11)}</div>
                        <div style={{ fontSize: "8px" }}><i className="bi bi-clock-history" />&nbsp;{props.time} </div>
                    </div>
                </div>
                <span className="px-2" style={{ fontSize: 20 }}>
                    <i className={props.sourceIcon} />
                </span>

            </div>
            <div className={`d-block p-2 ${props.direction === "incoming" ? "nodealed-content-task" : "dealed-content-task"}`} style={{ borderRadius: "0 0 10px 10px" }}>
                <div className="d-flex justify-content-between">
                    <div style={{ fontSize: "11px" }}>{props.author} {props.attachement ? <AttachementTemplate type={props.message.attachments[0].attachmentType} /> : utils.shorthandString(props.message.content)}</div>
                    {isCurrentTask() && <i className="bi bi-pin-angle-fill" />}
                </div>
                <TaskActionSet task={props.intervention} tasksView />
            </div>
        </div>
    );
}

export const TaskActionSet = (props) => {

    const isActionShouldDisplay = (nextStatus, actionStatus) => {
        return nextStatus?.some((item) => item.statusId === actionStatus);
    }

    return (
        <div className="d-flex justify-content-end" style={{ color: "#28566A" }}>
            {
                isActionShouldDisplay(props.task.nextStatus, INTERVENTION_STATUS.ACCEPTED) &&
                <ThumbActionTaskItem
                    idThumb={`accept-task-item${props.task.interventionId}`}
                    icon="bi bi-check-circle-fill"
                    message="Confirm to accept this intervention ?"
                    task={{ id: props.task.interventionId, status: INTERVENTION_STATUS.ACCEPTED }}
                    tooltip="Accept"
                    tasksView={props.tasksView}
                />
            }
            {
                isActionShouldDisplay(props.task.nextStatus, INTERVENTION_STATUS.TRANSFERRED) &&
                <ThumbActionTaskItem
                    idThumb={`transfer-task-item${props.task.interventionId}`}
                    icon="bi bi-arrow-up-right-circle-fill"
                    message="Confirm to transfer this intervention ?"
                    task={{ id: props.task.interventionId, status: INTERVENTION_STATUS.TRANSFERRED }}
                    tooltip="Transfer"
                    tasksView={props.tasksView}
                    title="Transfer the task"
                />
            }
            {
                isActionShouldDisplay(props.task.nextStatus, INTERVENTION_STATUS.DEFFERRED) &&
                <ThumbActionTaskItem
                    idThumb={`refer-task-item${props.task.interventionId}`}
                    icon="bi bi-clock-fill"
                    message="Confirm to defer this intervention ?"
                    task={{ id: props.task.interventionId, status: INTERVENTION_STATUS.DEFFERRED }}
                    tooltip="Defer"
                    tasksView={props.tasksView}
                    title="Defer the task"
                />
            }
            {
                isActionShouldDisplay(props.task.nextStatus, INTERVENTION_STATUS.ARCHIVED) &&
                <ThumbActionTaskItem
                    idThumb={`close-task-item${props.task.interventionId}`}
                    icon="bi bi-dash-circle-fill"
                    message="Confirm to archive this intervention ?"
                    task={{ id: props.task.interventionId, status: INTERVENTION_STATUS.ARCHIVED }}
                    tooltip="Archive"
                    tasksView={props.tasksView}
                />
            }
            {
                isActionShouldDisplay(props.task.nextStatus, INTERVENTION_STATUS.COMPLETED) &&
                <ThumbActionTaskItem
                    idThumb={`close-task-item${props.task.interventionId}`}
                    icon="bi bi-x-circle-fill"
                    message="Confirm to close this intervention ?"
                    task={{ id: props.task.interventionId, status: INTERVENTION_STATUS.COMPLETED }}
                    tooltip="Close"
                    tasksView={props.tasksView}
                    title="Enclose the task"
                />
            }
        </div>
    )
}

export const AttachementTemplate = (props) => {
    return (
        <small>
            <i className="pi pi-paperclip" /> &nbsp;{props.type} attachment
        </small>)
}

export const ThumbActionTaskItem = (props) => {

    const [visible, setVisible] = useState(false);
    const toastRef = useRef();
    const [loading, setLoading] = useState(false);
    const view = props.tasksView ? "task" : "folder";
    const [displayTaskActionPopup, setDisplayTaskActionPopup] = useState(false);
    const [targetTaskActionTemplate, setTargetTaskActionTemplate] = useState();

    const acceptFn = () => {
        switch (props.task.status) {
            case INTERVENTION_STATUS.COMPLETED: {
                setDisplayTaskActionPopup(true);
                setTargetTaskActionTemplate(<TaskEnclose
                    task={props.task}
                    view={view}
                    successCallback={(callback) => {
                        setDisplayTaskActionPopup(false);
                        toastRef?.current?.showToast({ type: "success", title: "Success", message: callback });
                    }}
                    errorCallback={(callback) => {
                        toastRef?.current?.showToast({ type: "warn", title: "Error", message: callback });
                    }}
                />);
                break;
            }
            case INTERVENTION_STATUS.TRANSFERRED: {
                setDisplayTaskActionPopup(true);
                setTargetTaskActionTemplate(<TaskTransfer
                    task={props.task}
                    view={view}
                    successCallback={(callback) => {
                        setDisplayTaskActionPopup(false);
                        toastRef?.current?.showToast({ type: "success", title: "Success", message: callback });
                    }}
                    errorCallback={(callback) => {
                        toastRef?.current?.showToast({ type: "warn", title: "Error", message: callback });
                    }} />);
                break;
            }
            case INTERVENTION_STATUS.DEFFERRED: {
                setDisplayTaskActionPopup(true);
                setTargetTaskActionTemplate(<TaskDefferHoc
                    task={props.task}
                    view={view}
                    successCallback={(callback) => {
                        setDisplayTaskActionPopup(false);
                        toastRef?.current?.showToast({ type: "success", title: "Success", message: callback });
                    }}
                    errorCallback={(callback) => {
                        toastRef?.current?.showToast({ type: "warn", title: "Error", message: callback });
                    }} />);
                break;
            }
            default: {
                dealActionService();
                break;
            }
        }
    }

    const dealActionService = () => {
        setLoading(true);
        TaskService.updatetaskStatus({
            taskId: props.task.id,
            status: props.task.status,
            view: view
        }).then(response => {
            setLoading(false);
            toastRef?.current?.showToast({ type: "success", title: "Success", message: response.message });
        }, error => {
            setLoading(false);
            toastRef?.current?.showToast({ type: "warn", title: "Error response", message: error, durable: true });
        });
    }

    const rejectFn = () => {
        setVisible(false);
    }

    //ENABLE BOOTSTRAP TOOLTIPS
    $(() => {
        $('[data-toggle="tooltip"]').tooltip()
    });

    return (
        <>
            <ConfirmPopup
                target={document.getElementById(props.idThumb)}
                visible={visible}
                onHide={() => setVisible(false)}
                message={`${props.message}`}
                icon={props.icon}
                accept={acceptFn}
                reject={rejectFn} />
            {
                !loading ?
                    <i
                        id={props.idThumb}
                        data-toggle="tooltip"
                        title={props.tooltip}
                        className={`mr-1 ${props.icon}`}
                        onClick={() => setVisible(true)}
                    /> :
                    <div className="sm-loader-container">
                        <ProgressLoader sm color={props.tasksView && "white"} />
                    </div>

            }
            <ToastNotification ref={toastRef} />

            <Popup
                header={props.title}
                visible={displayTaskActionPopup}
                onHide={() => setDisplayTaskActionPopup(false)}>
                <div className="task-action-modal" style={{ width: "30vw" }}>
                    {targetTaskActionTemplate}
                </div>
            </Popup>
        </>
    );
}